import { gql } from '@apollo/client';

// Unified medication-queue feed: returns both consultations and the pharmacy appointments linked to them
// as a single, server-ordered list of typed entries. `mode` selects the WAITING or RECEIVED_TODAY list.
export const GET_MEDICATION_QUEUE = gql`
  query GetMedicationQueue($input: MedicationQueueInput!) {
    medicationQueue: getMedicationQueue(input: $input) {
      aggregate {
        count
      }
      edges {
        node {
          id
          type
          time
          consultation {
            id
          }
          seenBy {
            id
            firstName
            lastName
          }
          dispensedBy {
            id
            firstName
            lastName
          }
          case {
            id
            caseId
            peopleProfile {
              id
              firstName
              lastName
              allergiesPresent
              allergyDetails
            }
          }
          consultationType {
            id
            name
          }
          status
        }
      }
    }
  }
`;
